import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';

import { AppRoutingModule } from './app-routing.module';

import { AppComponent } from './app.component';
import { HomeComponent } from './components/home/home.component';
import { DialogOverviewExampleDialog as Test1 } from './components/home/home.component';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SchoolComponent } from './components/school/school.component';

import { HttpClientModule } from '@angular/common/http';





// Material
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatMenuModule} from '@angular/material/menu';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSidenavModule} from '@angular/material/sidenav';
import {LayoutModule} from '@angular/cdk/layout';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatDividerModule} from '@angular/material/divider';
import {MatCardModule} from '@angular/material/card';
import {MatDialogModule} from '@angular/material/dialog';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatTabsModule} from '@angular/material/tabs';
import { NgxCarouselModule } from 'ngx-carousel';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatListModule} from '@angular/material/list';
import {MatTableModule} from '@angular/material/table';



import { SchoolService } from './services/school.service';
import { FacultyComponent } from './components/faculty/faculty.component';
import { FacultyService } from './services/faculty.service';
import { FacultyprofileComponent } from './components/facultyprofile/facultyprofile.component';
import { ContactComponent } from './components/contact/contact.component';
import { AboutComponent } from './components/about/about.component';
import { AboutService } from './services/about.service';
import { AcademicComponent } from './components/academic/academic.component';
import { AcademicService } from './services/academic.service';
import { ExaminationsComponent } from './components/examinations/examinations.component';
import { PageService } from './services/page.service';
import { RecruitmentComponent } from './components/recruitment/recruitment.component';
import { RecruitmentService } from './services/recruitment.service';
import { SupportFacilitiesComponent } from './components/support-facilities/support-facilities.component';
import { PagesComponent } from './components/pages/pages.component';
import { MediaComponent } from './components/media/media.component';
import { MainService } from './services/main.service';
import { NewsComponent } from './components/news/news.component';
import { TestComponent } from './components/test/test.component';
import { LibraryComponent } from './components/library/library.component';
import { LibraryService } from './services/library.service';
import { CccComponent } from './components/ccc/ccc.component';
import { culturalcouncilComponent } from './components/culturalcouncil/culturalcouncil.component';
import { OtherComponent } from './components/other/other.component';
import { TenderComponent } from './components/tender/tender.component';
import { PhotogalleryComponent } from './components/photogallery/photogallery.component';
import { MobileheaderComponent } from './components/mobileheader/mobileheader.component';
import { MobilefooterComponent } from './components/mobilefooter/mobilefooter.component';
import { NaacComponent } from './components/naac/naac.component';
import { AdmissionComponent } from './components/admission/admission.component';
import { AdmissionTeamComponent } from './admissions/components/admission-team/admission-team.component';
import { ForeignStudentComponent } from './admissions/components/foreign-student/foreign-student.component';
import { ChairpersonAdmissionsComponent } from './admissions/components/chairperson-admissions/chairperson-admissions.component';
import { ContactAdmissionsComponent } from './admissions/components/contact-admissions/contact-admissions.component';
import { Home1Component } from './components/home1/home1.component';
import { DialogOverviewExampleDialog } from './components/home1/home1.component';
import { IprcellComponent } from './components/iprcell/iprcell.component';
import { IprcellService } from './services/iprcell.service';
@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    DialogOverviewExampleDialog, Test1,
    HeaderComponent,
    FooterComponent,
    SchoolComponent,
    FacultyComponent,
    FacultyprofileComponent,
    ContactComponent,
    AboutComponent,
    AcademicComponent,
    ExaminationsComponent,
    RecruitmentComponent,
    SupportFacilitiesComponent,
    PagesComponent,
    MediaComponent,
    IprcellComponent,
    NewsComponent,
    TestComponent,
    LibraryComponent,
    CccComponent,
    culturalcouncilComponent,
    OtherComponent,
    TenderComponent,
    PhotogalleryComponent,
    MobileheaderComponent,
    MobilefooterComponent,
    NaacComponent,
    AdmissionComponent,
    AdmissionTeamComponent,
    ForeignStudentComponent,
    ChairpersonAdmissionsComponent,
    ContactAdmissionsComponent,
    Home1Component,
    IprcellComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MatToolbarModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSidenavModule,
    LayoutModule,
    MatProgressBarModule,
    MatDividerModule,
    MatCardModule,
    MatDialogModule,
    MatGridListModule,
    MatTabsModule,
    NgxCarouselModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatExpansionModule,
    MatListModule,
    MatTableModule
  ],
  providers: [SchoolService, FacultyService, AboutService, AcademicService, PageService, RecruitmentService, MainService, LibraryService, IprcellService],
  bootstrap: [AppComponent],
  entryComponents: [
    DialogOverviewExampleDialog, Test1,
  ],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts